<breadcrumb-layout>
	<li>
		<breadcrumb-item-view (action)="goToSettings()">
			{{ 'header_account-settings' | translate }}
		</breadcrumb-item-view>
	</li>
</breadcrumb-layout>
